import { Injectable, inject } from '@angular/core';
import { OidcSecurityService } from "angular-auth-oidc-client";
import { environment } from "../../../environments/environment";
import { RolesEnum, RoutesEnum } from "../utils/RoutesEnum";

@Injectable( {
  providedIn: 'root'
} )
export class AuthService {
  
  private oidcSecurityService = inject(OidcSecurityService);

  roles = [];

  getRoles(): any[] {
    this.oidcSecurityService.getIdToken().subscribe(token => {
      if (token) {
        const payload = JSON.parse(atob(token.split('.')[1]));
          this.roles=payload['cognito:groups'] || payload['role'] || [];
      }
    });

    return this.roles || [];
  }

  async logout() {

    await this.oidcSecurityService.logoff( '',{customParams:{
            authority: environment.Authority_URL,
            redirect_uri: window.location.origin,
            client_id: environment.Client_ID,
            scope: 'email openid',
            response_type: 'code'
        }}).subscribe();
  }


  routeEnabledModule(): string {
    if( ( this.roles.includes( RolesEnum.AdminRole ) || this.roles.includes(
      RolesEnum.EditorRole ) || this.roles.includes( RolesEnum.ViewerRole ) ) ) {
      return RoutesEnum.KPIDashboard;
    }
    else if(( this.roles.includes( RolesEnum.AdminRole ) || this.roles.includes(
      RolesEnum.EditorRole ) ) ) {
      return RoutesEnum.RevenueManager;
    }
    else if(( this.roles.includes( RolesEnum.AdminRole ) || this.roles.includes(
      RolesEnum.EditorRole ) || this.roles.includes( RolesEnum.ViewerRole ) ) ) {
      return RoutesEnum.BookingOverview;
    }
    else if(( this.roles.includes( RolesEnum.AdminRole ) || this.roles.includes(
      RolesEnum.EditorRole ) || this.roles.includes( RolesEnum.ViewerRole ) ) ) {
      return RoutesEnum.FxRate;
    }
    else if(this.roles.includes( RolesEnum.AdminRole ) ) {
      return RoutesEnum.ClusterPricing;
    }
    else if(this.roles.includes( RolesEnum.SuperAdminRole ) ) {
      return RoutesEnum.SuperAdminSettings;
    }
    else if(this.roles.includes( RolesEnum.AdminRole ) ) {
      return RoutesEnum.Settings;
    }
    else if(this.roles.includes( RolesEnum.AdminRole ) ) {
      return RoutesEnum.strategyPriceOverride;
    }
    else {
      return RoutesEnum.PageNotFound
    }
  }
}
